var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle, size: "2xl", withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", [
              _c("div", { staticClass: "flex flex-col gap-4" }, [
                _c(
                  "div",
                  [
                    _c("VisitsTable", {
                      attrs: {
                        currentMode: _vm.currentMode,
                        data: _vm.client,
                        headers: _vm.headers,
                        handleSelectAll: _vm.handleSelectAll,
                        areAllItemsSelected: _vm.areAllItemsSelected,
                        handleRowCheckboxChange: _vm.handleRowCheckboxChange,
                        isInPopup: false,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-col items-end" },
                  [
                    _c("UIButton", {
                      staticClass: "font-outfit",
                      attrs: {
                        buttonText: _vm.buttonText,
                        variant: "black",
                        size: "sm",
                        disabled: _vm.selectedVisits.length === 0,
                      },
                      on: { click: _vm.submit },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }